import React from "react"
import DesktopMenu from "./deskTopMenu"
import MobileMenu from "./mobileMenu"
import logo from '../../images/logo.png'

const MenuList = [
    [
        'INTRODUCTION', // title
        '/#intro', // Link
        'px-3 py-1 mx-1', // Class for Desktop
        'px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Features',
        '/#features', 
        'px-3 py-1 mx-1', // Class for Desktop
        'px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'TOKENOMICS',
        '/#tokenomics', 
        'px-3 py-1 mx-1', // Class for Desktop
        'px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'FAQs',
        '/#faqs',
        'px-3 py-1 mx-1', // Class for Desktop
        'px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
    [
        'Dapp',
        'dashboard',
        // 'blank',
        'px-3 py-1 mx-1', // Class for Desktop
        'px-3 py-2 mx-3 pr-5' // Class for Mobile
    ],
];
const Menu = () => {
    return(
        <div>
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </div>
    )
}

export default Menu;